import React, { useState } from 'react';
import { useTranslate } from 'app/translations';
import { displayName, isSameUser } from 'utilities/names';

export const Name = (props) => {
    const { _t } = useTranslate();
    const { user, target, email } = props;

    const hasMoreInfo = !!target && typeof target === 'object';
    const targetName = displayName(target);

    const isSelf = isSameUser(user, target, email);
    const name = isSelf ? _t('ticket.history.you') : targetName;
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const formattedName = !name || name.toLowerCase() === 'system' ? _t('system') : name;

    return (
        <span
            className={`relative group`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
           {formattedName}
           {(isHovered && hasMoreInfo && !isSelf) && (
                <div className="absolute z-10 p-2 mt-2 bg-surface text-sm text-black rounded-lg shadow-md w-60">
                    <div className="font-bold">{targetName}</div>
                    {target?.email && (
                        <div>{_t('ticket.history.email')}: {target?.email}</div>
                    )}
                    {target?.profilePicture && (
                        <div className="my-2">
                            <img src={target?.profilePicture} alt="profile" className="rounded-full w-10 h-10"/>
                        </div>
                    )}
                </div>
            )}
        </span>
     )
}
